import { cn, io } from 'lib/helpers/utility';

import DisplayButton from 'components/shared/AGTable/DisplayButton';
import Filters from 'components/shared/Filters/Filters';
import FilterActions from 'components/shared/Filters/components/FilterActions';

const TableFilters = ({
  filters,
  initialFilters,
  setFilters,
  category,
  defaultFilters,
  isEditingFilter,
  className = '',
  disableActions = false
}) => {
  return (
    <div
      className={cn(
        'outline-b flex items-start justify-between gap-2 bg-white px-4 py-2 outline-1 outline-offset-[-1px] outline-neutral-200',
        className
      )}>
      {io(defaultFilters) ? (
        <Filters defaultFilters={defaultFilters} filters={filters} setFilters={setFilters} />
      ) : (
        <div />
      )}
      <div className="flex flex-wrap items-start justify-end gap-2">
        <DisplayButton />
        {filters && (
          <FilterActions
            filters={filters}
            initialFilters={initialFilters}
            setFilters={setFilters}
            category={category}
            isEditingFilter={isEditingFilter}
            disableActions={disableActions}
          />
        )}
      </div>
    </div>
  );
};

export default TableFilters;
